import { Link } from 'react-router-dom';

const featured = [
  {
    icon: 'ri-ship-2-line',
    tag: 'FCL',
    title: 'Full Container Load',
    desc: 'Expédition de conteneurs complets 20" et 40" HC pour vos volumes importants.',
    img: 'https://storage.helloreaddy.io/project_files/179a8203-21a2-4b5f-9e7d-c89fcdd8c7e7/1c882bfa-bcd0-4a3f-920f-36acec91fc86_compressed_540c4cd6-1c2a-461f-a19a-48a81874099a.webp',
  },
  {
    icon: 'ri-stack-line',
    tag: 'LCL',
    title: 'Less than Container Load',
    desc: 'Groupage maritime pour optimiser les coûts de vos petits volumes.',
    img: 'https://storage.helloreaddy.io/project_files/179a8203-21a2-4b5f-9e7d-c89fcdd8c7e7/eb2441b7-66e5-4d79-85f0-30f71e96317e_compressed_901a962e-0596-4553-b123-dda172b8634a.webp',
  },
  {
    icon: 'ri-home-gear-line',
    tag: 'Door-to-Door',
    title: 'House to House',
    desc: 'Service porte-à-porte complet depuis la Chine jusqu\'à votre adresse en RDC.',
    img: 'https://readdy.ai/api/search-image?query=Logistics%20delivery%20truck%20arriving%20at%20residential%20building%20door%20with%20cargo%20being%20unloaded%20by%20professional%20movers%2C%20door%20to%20door%20shipping%20service%2C%20warm%20natural%20light%20clean%20neutral%20background%20editorial%20photography&width=800&height=600&seq=gls-sol-door&orientation=landscape',
  },
];

export default function HomeSolutions() {
  return (
    <section className="py-20 md:py-28 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <span className="text-primary-600 text-sm font-semibold uppercase tracking-widest">Nos solutions</span>
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-900 mt-3 leading-tight">
              Des solutions maritimes et financières taillées pour vos flux
            </h2>
          </div>
          <Link to="/solutions" className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-primary-500 hover:bg-primary-600 text-white text-sm font-semibold whitespace-nowrap cursor-pointer transition shrink-0">
            Toutes nos solutions <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>

        <div className="grid md:grid-cols-3 gap-6 md:gap-8">
          {featured.map((s, i) => (
            <div key={i} className="group bg-background-50 rounded-lg overflow-hidden border border-background-200 hover:border-primary-300 transition">
              <div className="relative h-52 overflow-hidden">
                <img src={s.img} alt={s.title} className="w-full h-full object-cover object-top group-hover:scale-105 transition duration-500" />
                <div className="absolute top-4 left-4 px-3 py-1 rounded-full bg-primary-500 text-white text-xs font-bold uppercase tracking-wider">
                  {s.tag}
                </div>
              </div>
              <div className="p-6 md:p-7">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-md bg-primary-100 text-primary-600">
                    <i className={`${s.icon} text-lg`}></i>
                  </div>
                  <h3 className="font-heading text-lg font-bold text-foreground-900">{s.title}</h3>
                </div>
                <p className="text-foreground-700 text-sm leading-relaxed">{s.desc}</p>
                <Link to="/contact" className="inline-flex items-center gap-2 mt-5 text-primary-600 hover:text-primary-700 text-sm font-semibold cursor-pointer whitespace-nowrap">
                  Demander cette solution <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}